import { render, staticRenderFns } from "./CmgLeaderboardRanks.vue?vue&type=template&id=54baed55&scoped=true&lang=pug"
import script from "./cmg-leaderboard-ranks.ts?vue&type=script&lang=ts&external"
export * from "./cmg-leaderboard-ranks.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgLeaderboardRanks.vue?vue&type=style&index=0&id=54baed55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54baed55",
  null
  
)

export default component.exports